import {http, onSuccess, onFail} from "./http";

export const getCometServers = () =>
    http.get(`/api/cp/comet`)
        .then(onSuccess, onFail);
